/* Brainwave testimonial slider. Progressive enhancement: without JS the track
   is still a horizontally scrollable list, so every review stays reachable. */
class BWSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.bw-quotes');
    this.dots = this.querySelector('.bw-dots');
    this.slides = Array.from(this.track ? this.track.children : []);
    if (!this.track || this.slides.length === 0) return;

    this.arrows = Array.from(this.querySelectorAll('.bw-slider__arrow'));
    this.arrows.forEach((a) =>
      a.addEventListener('click', () => this.track.scrollBy({ left: this.step() * Number(a.dataset.dir), behavior: 'smooth' }))
    );
    this.track.addEventListener('scroll', () => this.sync());
    window.addEventListener('resize', () => this.build());
    this.build();
  }

  perView() { return window.innerWidth <= 991 ? 1 : Number(this.dataset.perView || 2); }
  gap() { return parseFloat(getComputedStyle(this.track).columnGap || 32) || 32; }
  step() { return (this.slides[0].offsetWidth + this.gap()) * this.perView(); }
  pages() { return Math.max(1, Math.ceil(this.slides.length / this.perView())); }

  build() {
    if (!this.dots) return this.sync();
    this.dots.innerHTML = '';
    for (let i = 0; i < this.pages(); i++) {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', `Go to review ${i + 1}`);
      b.addEventListener('click', () => this.track.scrollTo({ left: i * this.step(), behavior: 'smooth' }));
      this.dots.appendChild(b);
    }
    this.sync();
  }

  sync() {
    const step = this.step();
    const idx = step ? Math.round(this.track.scrollLeft / step) : 0;
    if (this.dots) {
      Array.from(this.dots.children).forEach((d, i) => d.setAttribute('aria-current', i === idx ? 'true' : 'false'));
    }
    const atStart = this.track.scrollLeft < 4;
    const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
    this.arrows.forEach((a) => { a.disabled = Number(a.dataset.dir) < 0 ? atStart : atEnd; });
  }
}
if (!customElements.get('bw-slider')) customElements.define('bw-slider', BWSlider);
